module.exports = function getResource(label, vars = []) {
    const resources = {
        privacyPolicy: 'Privacy Policy.',
        andConditionsOfUse: 'Conditions of Use, have read the ',
        noticeOfFinancialIncentive: 'Notice of Financial Incentive.',
        noShippingAddressRequired:
            'No shipping address or payment is required for this order. Please review your information before placing your order.',
        noPaymentRequired: 'No payment is required for this order. Please review your information before placing your order.',
        pleaseReviewOrder: `Please review your order information before ${vars[0]}`,
        termsConditions: 'Terms & Conditions',
        andText: ' and ',
        pleaseReviewOrderInfoText: 'Please review your order information before placing your order.',
        byPlacingOrderCaText: 'By placing your order, you agree to be bound by the ',
        termsOfPurchase: 'Terms of Purchase',
        termsOfUse: 'Terms of Use',
        iAgreeToSephora: 'I Agree to Sephora’s ',
        termsAndConditions: 'Terms & Conditions ',
        forTheSubscription:
            ' for the subscription and authorize Sephora to charge my default payment method or another payment method on file. My subscription continues until canceled. I acknowledge I can cancel at any time via the Auto-Replenish page in My Account.',
        byClickingPlaceOrder: 'By clicking Place Order button, I also agree to Sephora’s ',
        termsOfService: 'Terms of Service ',
        iAgreeToAutoReplenish: 'I Agree to the Auto-Replenish ',
        andConditionsOfUseHaveRead: 'Conditions of Use, and have read the '
    };
    return resources[label];
};
